/**
 * Calculate adjusted costs for trait shuffling based on cost slider value
 *
 * Formula:
 * - Maximum algo reduction: baseAlgoCost - 5 (minimum algo cost is 5)
 * - Algo reduction: (costSliderValue / 100) * maxAlgoReduction
 * - New algo cost: baseAlgoCost - algoReduction
 * - Treat increase: algoReduction * 150 (150 treats per 1 algo reduced)
 * - New treats cost: baseTreatsCost + treatIncrease
 *
 * @param {number} costSliderValue - Slider value from 0-100 (0 = default costs, 100 = max treats/min algo)
 * @param {number} baseTreatsCost - Base TREATS cost from config
 * @param {number} baseAlgoCost - Base ALGO cost from config
 * @returns {Object} - { treats: number, algo: number }
 *
 * @example
 * // With base costs of 1000 TREATS + 25 ALGO:
 * calculateTraitShuffleCosts(0, 1000, 25)   // { treats: 1000, algo: 25 }
 * calculateTraitShuffleCosts(50, 1000, 25)  // { treats: 2500, algo: 15 }
 * calculateTraitShuffleCosts(100, 1000, 25) // { treats: 4000, algo: 5 }
 */
export const calculateTraitShuffleCosts = (costSliderValue, baseTreatsCost, baseAlgoCost) => {
  // Maximum algo reduction (minimum algo cost is 5)
  const maxAlgoReduction = baseAlgoCost - 5;

  // Calculate how much algo to reduce based on slider (0-100)
  const algoReduction = Math.round((costSliderValue / 100) * maxAlgoReduction);
  const newAlgoCost = baseAlgoCost - algoReduction;

  // For each 1 algo reduced, increase treats by 150
  const treatIncrease = algoReduction * 150;
  const newTreatsCost = baseTreatsCost + treatIncrease;

  return {
    treats: newTreatsCost,
    algo: newAlgoCost,
  };
};
